/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Move_To_PreferencesInputs */



/**
* | output |
* | --- |
* | "Move to “Preferences”" |
*
* @param {Memory_Move_To_PreferencesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_move_to_preferences = /** @type {((inputs?: Memory_Move_To_PreferencesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Move_To_PreferencesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu „Präferenzen“ verschieben")
	return /** @type {LocalizedString} */ ("Move to “Preferences”")
});